<template>
  <div class="map-legend-wrapper">
    <color-legend :orientation="'horizontal'"></color-legend>
  </div>
</template>

<script>
import ColorLegend from '../color-legend/ColorLegend';

export default {
  name: 'map-legend',
  components: {
    'color-legend': ColorLegend,
  },
};
</script>

<style lang="less">
  .map-legend-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    @media (max-width: 800px) and (min-width:500px) {
      margin-left: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// MapControlsLegend.vue?2643dbd3